import React, { Suspense } from 'react';

import { Provider } from 'react-redux';
import configureStore from './store';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import routes from './routes';

const store = configureStore({});

function App() {
  return (
    <div className='App'>
      <Provider store={store}>
        <Router>
          <Suspense
            fallback={
              <div
                className='login-flow'
                style={{ padding: '48px', textAlign: 'center' }}
              >
                Загрузка…
              </div>
            }
          >
            <Switch>
              {routes.map(route => (
                <Route key={route.path} {...route} />
              ))}
            </Switch>
          </Suspense>
        </Router>
      </Provider>
    </div>
  );
}

export default App;
